import React from "react";

const useStorage = (key, initialValue, storageObject) => {
    const [value, setValue] = React.useState(() => {
        const storedValue =
            storageObject === window.sessionStorage
                ? sessionStorage.getItem(key)
                : localStorage.getItem(key);
        return storedValue !== null ? JSON.parse(storedValue) : initialValue;
    });

    React.useEffect(() => {
        storageObject.setItem(key, JSON.stringify(value));
        if (value === undefined) return storageObject.removeItem(key);
    }, [key, value, storageObject]);

    const remove = React.useCallback(() => setValue(undefined), []);

    return [value, setValue, remove];
};

export default useStorage;

//  usage
// const [name, setName, remove] = useStorage('name', '', window.localStorage);
